export default "__VITE_ASSET__ce469fbb__"